import { Button } from "@chakra-ui/react";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import LoadingButton from "../../../../../shared/components/LoadingButton";
import Select, { CustomSelectProps } from "../../../../../shared/components/Select";
import SelectNoResults from "../../../../../shared/components/SelectNoResults";
import useApi from "../../../../../shared/hooks/useApi";
import { queryKeys } from "../../../../../shared/query-keys";
import { IntakeTrackId } from "../../../../../shared/schema/schema";

export function IntakeTracksSelect(props: CustomSelectProps<IntakeTrackId>) {
  const { api } = useApi();
  const query = useQuery({
    queryKey: queryKeys.patientIntake.intakeTracks(),
    placeholderData: keepPreviousData,
    queryFn: () => api.get("./patient_intake/intake_tracks", {}),
  });

  switch (query.status) {
    case "pending":
      return <LoadingButton />;
    case "error":
      return (
        <Button
          isDisabled={true}
          justifyContent="flex-start"
          variant="outline"
          {...props.buttonProps}
        >
          Failed to render input
        </Button>
      );
    case "success":
      return (
        <Select
          label={props.label ?? (props.multiple ? "Intake tracks" : "Intake track")}
          options={query.data.tracks.map((track) => ({
            label: track.name,
            value: track.id,
          }))}
          renderAfter={({ searchTerm, filteredOptions }) =>
            filteredOptions.length === 0 && <SelectNoResults searchTerm={searchTerm} />
          }
          {...props}
        />
      );
  }
}
